<div class="tab-pane active container-fluid" role="tabpanel" aria-labelledby="location-search-tab">
    <div class="d-flex">
        <jhi-column-filter [request]="request" [resultSearch]="resultSearch" [filters]="filters" [eventName]="COLUMN_FILTER_EVENT_NAME"
                           class="flex-sm-grow-1"></jhi-column-filter>
    </div>
    <br/>
    <div class="row">
        <div class="col">
            <div class="mb-3 d-flex align-items-center">
                <jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
                <div style="margin-left: 10px;">
                    <a href (click)="onClearSort($event)" jhiTranslate="global.clear-sort"></a>
                </div>
                <span *ngIf="isLoading" style="margin-left: 10px;" class="throbber"></span>
            </div>
        </div>
    </div>
    <br/>
    <div class="table-responsive" *ngIf="breedingMethods">
        <table class="table table-striped table-bordered table-curved" *ngIf="breedingMethods.length else nodata">
            <thead>
            <tr jhiSort [(predicate)]="predicate" [(ascending)]="reverse" [callback]="transition.bind(this)">
                <th [jhiSortBy]="ColumnLabels.NAME"><span jhiTranslate="program-settings-manager.breeding-methods.search.columns.method-name"></span> <span class="fa fa-sort"></span></th>
                <th [jhiSortBy]="ColumnLabels.DESCRIPTION"><span jhiTranslate="program-settings-manager.breeding-methods.search.columns.description"></span> <span class="fa fa-sort"></span></th>
                <th [jhiSortBy]="ColumnLabels.GROUP"><span jhiTranslate="program-settings-manager.breeding-methods.search.columns.group"></span> <span class="fa fa-sort"></span></th>
                <th [jhiSortBy]="ColumnLabels.CODE"><span jhiTranslate="program-settings-manager.breeding-methods.search.columns.code"></span> <span class="fa fa-sort"></span></th>
                <th [jhiSortBy]="ColumnLabels.TYPE"><span jhiTranslate="program-settings-manager.breeding-methods.search.columns.type"></span> <span class="fa fa-sort"></span></th>
                <th [jhiSortBy]="ColumnLabels.DATE"><span jhiTranslate="program-settings-manager.breeding-methods.search.columns.date"></span> <span class="fa fa-sort"></span></th>
                <th [jhiSortBy]="ColumnLabels.CLASS_NAME"><span jhiTranslate="program-settings-manager.breeding-methods.search.columns.class"></span> <span class="fa fa-sort"></span></th>
                <th [jhiSortBy]="ColumnLabels.FAVORITE_PROGRAM_UUID"><span jhiTranslate="program-settings-manager.breeding-methods.search.columns.program-favorite"></span> <span class="fa fa-sort"></span></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let breedingMethod of breedingMethods; trackById: trackId; index as index">
                <td>{{breedingMethod.name}}</td>
                <td><span class="text-ellipsis" title="{{breedingMethod.description}}">{{breedingMethod.description}}</span></td>
                <td>{{breedingMethod.group}}</td>
                <td>{{breedingMethod.code}}</td>
                <td>{{breedingMethod.type}}</td>
                <td>{{breedingMethod.creationDate}}</td>
                <td>{{breedingMethod.methodClassName}}</td>
                <td class="text-center">
                    <button class="btn btn-sm btn-light" (click)="toggleProgramFavorite(breedingMethod)"><i [ngClass]="(isProgramFavorite(breedingMethod)) ? 'fa-icon-active fa fa-star' : 'non-favorite fa fa-star'"></i></button>
                </td>
            </tr>
            </tbody>
        </table>
        <ng-template #nodata>
            <table class="table table-striped table-bordered table-curved">
                <thead>
                <tr>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td jhiTranslate="no.data"></td>
                </tr>
                </tbody>
            </table>
        </ng-template>
    </div>
    <div *ngIf="breedingMethods && breedingMethods.length">
        <div class="row">
            <div class="col">
                <div class="pagination-container">
                    <div class="pagination-box pagination-box-left">
                        <div>
                            <jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
                        </div>
                    </div>
                    <div class="pagination-box">
                        <ngb-pagination [collectionSize]="totalItems" [(page)]="page" [pageSize]="itemsPerPage" [disabled]="isLoading"
                                        [maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="loadPage(page)"></ngb-pagination>
                    </div>
                    <div class="pagination-box pagination-box-right">
                        <div class="d-flex align-items-center">
                            <label for="itemsPerPage" class="control-label control-label-left" jhiTranslate="global.items.per.page"></label>
                            <select [(ngModel)]="itemsPerPage" class="form-select ms-2" id="itemsPerPage" [disabled]="isLoading" (change)="resetTable();" style="width:95px">
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="75">75</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
